import React from "react";

const Spec = (
  {
    title = "",
    subTitle = "",
    body = "",
    children
  }
) => {
  return (
    <div className="spec">
      {children && (children)}
      {title && (
        <h6 className="spec__title" dangerouslySetInnerHTML={{__html: title}} />
      )}
      {subTitle && (
        <div className="spec__sub-title">{subTitle}</div>
      )}
      {body && (
        <p className="spec__body">{body}</p>
      )}
    </div>
  )
}

export default Spec
